<template>
  <div class="normal-box-small" v-if="show">
    <img src="../assets/normal.png">
    {{ text }}
  </div>
</template>

<script>

export default {
  name: 'normal-box',
  props: {
    show: {
      default: false,
    },
    text: {
      default: '暂无数据',
    },
  },
}
</script>

<style scoped>
.normal-box-small {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  color: #999992;
  padding: 50px 0;
}

.normal-box-small > img {
  width: 150px;
  margin-bottom: 9px;
}
</style>
